@for (column of displayedColumns; track column) {
  @if (column.showMobile) {
    <div class="d-flex align-items-center justify-content-center accordion-mobile-item"
      [ngClass]="{ 'mt-2': column.columnName === 'status' }">
      <div class="ps-3 w-100 align-items-center justify-content-center">
        <span class="lato-font text-secondary mobile-text" translate="Table.{{column.transTag}}"></span><br />
        <span>
          {{ tableData[column.columnName] | valueByTypePipe : column.type }}
          @if (column.type === 'Guid') {
            <em class="bi bi-copy cursor-pointer float-end pe-3" aria-hidden="true"
              (click)="copyToClipboard(tableData[column.columnName])"
            (keydown)="copyToClipboard(tableData[column.columnName])"></em>
          }
          @if (column.columnName === 'status') {
            @if (displayWithdrawnHeader) {
              <div class="break-words me-1">
                <div class="alert alert-danger p-1 mt-0 white-space table-alert-box-font-size me-2 mb-3" role="alert">
                  {{request.withdrawnUserName}} : {{request.withdrawnReason}}
                </div>
              </div>
            }
            @if (displayEmailErrorHeader) {
              <div class="break-words me-1">
                <div class="alert alert-danger p-1 mt-0 white-space table-alert-box-font-size me-2 mb-3" role="alert"
                  translate="EmailActivities.ErrorWith"
                  [translateParams]="{email: request.emailError_Email,name: request.emailError_Name,event: request.emailError_Event}">
                </div>
              </div>
            }
            @if (displayRejectionHeader) {
              <div class="break-words me-1">
                <div class="alert alert-danger p-1 mt-0 white-space table-alert-box-font-size me-2 mb-3" role="alert">
                  {{request.rejectionUserName}} : {{request.rejectionReason}}
                </div>
              </div>
            }
            @if (displayDigipoortErrorHeader) {
              <div class="break-words me-1">
                <div class="alert alert-danger p-1 mt-0 white-space table-alert-box-font-size me-2 mb-3" role="alert">
                  {{request.digipoortErrorMessage}}
                </div>
              </div>
            }
            @if (displaySbrNexusErrorHeader) {
              <div class="break-words me-1">
                <div class="alert alert-danger p-1 mt-0 white-space table-alert-box-font-size me-2 mb-3" role="alert">
                  {{request.sbrNexusErrorMessage}}
                </div>
              </div>
            }
          }
        </span>
      </div>
    </div>
  }
}